<template>
  <div class="text-block">
    <h1>{{ title }}</h1>
    <p v-if="description">{{ description }}</p>
    <ul
      class="category-links-list"
      v-if="links.length > 1"
    >
      <li
        v-for="link in links"
        v-bind:key="link.to"
      >
        <router-link
          class="category-link"
          v-bind:to="link.to"
        >{{ link.text }}</router-link>
      </li>
    </ul>
    <p
      class="category-link-wrapper"
      v-else-if="links.length === 1"
    >
      <router-link
        class="category-link"
        v-bind:to="links[0].to"
      >{{ links[0].text }}</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'MainTextBlock',
  props: ['title', 'text'],
  data: function () {
    return {
      linksPattern: /-[ ]+\[.+?\]\([\w/]+\)/g,
      linksGroupsPattern: /\[(.+?)\]\(([\w/]+)\)/
    }
  },
  computed: {
    links: function () {
      let matches = this.text.match(this.linksPattern)
      if (!matches) {
        return []
      }
      return matches.map(function (item) {
        let linkItems = item.match(this.linksGroupsPattern)
        return {text: linkItems[1], to: linkItems[2]}
      }, this)
    },
    description: function () {
      let description = this.text.replace(this.linksPattern, '')
      return description.replace(/(?:\r\n|\r|\n)/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
  .text-block {
    @include text-block();

    & > .category-links-list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      & > li {
        @include media("<=mobile") { flex-grow: 1; }
        margin: 0.5em;
      }
    }
    & > .category-link-wrapper {
      padding: 0.5em;
    }
    .category-link {
      @include framed-color-reversible-button();
      @include media("<=mobile") { display: block; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/main/MainTextBlock.vue